import { Vue } from 'vue-property-decorator';

import moment from 'moment';

import accountService from '@/services/account.service';
import cookieService from '@/services/cookie.service';
import routeService from '@/services/route.service';
import userService from '@/services/user.service';

import { ITokenModel, IRefreshTokenModel } from '@/models/token.model';
import { IUserModel } from '@/models/account.model';
import { ICookiesResultModel } from '@/models/cookie.model';
import { ILogOutResultModel } from '@/models/login.model';
import { IRefreshTokenRequest, IVerifyTokenRequest } from '@/models/auth.model';

export default {
  setToken(context: Vue, redirect: boolean, checkSteamUrl: boolean = true, cookies?: any): void {
    context.$store.dispatch("updateIsLoading", true);
    let redirectUrl = context.$route.query.redirectUrl;
    let storedRedirectUrl = localStorage.getItem("g2g_redirect_url");

    if (!!storedRedirectUrl && (redirectUrl == '' || !redirectUrl)) {
      redirectUrl = storedRedirectUrl;
      redirect = true;
    }

    const token = context.$cookies.get("_g2g_identity_");

    if (token == null) {
      context.$store.dispatch("updateIsLoading", false);

      routeService.redirectToHome(context, redirectUrl != null ? redirectUrl.toString() : undefined);

      return;
    }

    const body : IVerifyTokenRequest = {
      AccessToken: token,
      ClientId: context.$data.RCEnvironment.VUE_APP_API_KEY,
    };

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "token";

    accountService.post<IVerifyTokenRequest,ITokenModel>(context, url, body, { headers: { "Cache-Control": "no-cache" } })
      .then(async response => {

        if (response == null) {
          context.$cookies.remove("_g2g_identity_");
          context.$store.dispatch("updateIsLoading", false);

          routeService.redirectToHome(context, redirectUrl != null ? redirectUrl.toString() : undefined);
          return;
        }

        if (!response.Validated || response.Refreshed) {
          context.$cookies.remove("_g2g_identity_");
          context.$store.dispatch("updateIsLoading", false);

          routeService.redirectToHome(context, redirectUrl != null ? redirectUrl.toString() : undefined);
          return;
        }

        if (!response.Refreshed && moment(response.ExprireAt) <= moment()) {
          context.$cookies.remove("_g2g_identity_");
          context.$store.dispatch("updateIsLoading", false);

          routeService.redirectToHome(context, redirectUrl != null ? redirectUrl.toString() : undefined);
          return;
        }

        await context.$store.dispatch("updateToken", response);

        if (token != null) {
          this.setGtag(context, token, response.Id_User);

          await userService.updateUser(context, checkSteamUrl, redirect, response.Id_User, token, context.$store.getters.redirectUrl, false);
        }
      })
      .catch(() => {
        context.$cookies.remove("_g2g_identity_");

        context.$store.dispatch("updateIsLoading", false);
        routeService.redirectToHome(context);
        return false;
      });
  },

  refreshToken(context: Vue, token: ITokenModel, redirect: boolean, checkSteamUrl: boolean = true): void {
    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + 'token/refresh';

    const body: IRefreshTokenRequest = {
      AccessToken: token.Value,
      RefreshToken: token.Refresh,
      ClientId: context.$data.RCEnvironment.VUE_APP_API_KEY,
    };

    accountService.post<IRefreshTokenRequest,IRefreshTokenModel>(context, url, body, { headers: { "Cache-Control": "no-cache" } })
      .then(async response => {
        const now = new Date();
        context.$cookies.set("_g2g_identity_", response.AccessToken, new Date(now.setDate(now.getDate() + 30)), '/', undefined, undefined, "Strict");
        this.setToken(context, redirect, checkSteamUrl);
      })
      .catch(() => {
        context.$store.dispatch("updateIsLoading", false);
        routeService.redirectToHome(context);
      });
  },

  setGtag(context: Vue, tokenValue: string, user?: number): void {
    if (user != null) {
      const token = tokenValue != null ? tokenValue : context.$store.getters.token.Value;
      const urlCookies: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie/user/" + user;

      accountService.get<ICookiesResultModel>(context, urlCookies, { headers: { Authorization: "Bearer " + token } })
        .then(cookies => {
          const analyticalCookie = cookies.Cookies.find(cookie => cookie.Name == "Analytical cookies");
          if (analyticalCookie != null) {
            analyticalCookie.IsAccepted ? cookieService.enableAnalytics(context) : cookieService.disableAnalytics(context);
          }

          const marketingCookie = cookies.Cookies.find(cookie => cookie.Name == "Marketing cookies");
          if (marketingCookie != null) {
            marketingCookie.IsAccepted ? cookieService.enableAnalytics(context, true) : cookieService.disableAnalytics(context, true);
          }
        })
    }
  },

  hasToken(context: Vue): string {
    const token: string = context.$cookies.get("_g2g_identity_");

    if (token) {
      this.statLogin(context, token);
    }

    return token;
  },

  statLogin(context: Vue, token: string): void {
    accountService.post(
      context,
      context.$data.RCEnvironment.VUE_APP_API_URL.concat('stats/log'),
      { Source: 1 },
      { headers: { Authorization: "Bearer " + token }
    });
  },

  logOut(context: Vue, id?: string) {
    const token = context.$cookies.get("_g2g_identity_");
    const userId = id ? id : context.$store.getters.user.Id;
    context.$store.dispatch("updateIsLoading", true);

    if (token != null && userId != null) {
      const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/user/" + userId + "/log-out";
      accountService.post<object, ILogOutResultModel>(context, url, {}, { headers: { Authorization: "Bearer " + token } })
        .then((result: ILogOutResultModel) => {
          context.$cookies.remove("_g2g_identity_");

          if (result.CookieName != null && result.CookieName != undefined && result.CookieName != '') {
            const domain = routeService.getMainDomain(context);
            context.$cookies.remove(result.CookieName, "/", domain);
          }

          context.$store.dispatch("updateUser", {} as IUserModel).then(() => {
            context.$store.dispatch("updateToken", {} as ITokenModel).then(() => {
              context.$store.dispatch("updateIsLoading", false);

              if (context.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'STILLFRONT') {
                const redirectUri = context.$store.getters.redirectUrl ? context.$store.getters.redirectUrl : context.$data.RCEnvironment.VUE_APP_ACCOUNT_URL;
                window.location.href = "https://playsupremacy.com/api/auth/logout?post_logout_redirect_uri=" + redirectUri;
              } else {
                if (context.$store.getters.redirectUrl) {
                  window.location.href = context.$store.getters.redirectUrl;
                  return;
                }

                context.$router.push({ name: 'Home' });
              }
            });
          });
        })
        .catch(() => {
          context.$store.dispatch("updateIsLoading", false);
        });
    }
  }
}
